import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { SIGNALS } from "@/data/signals";
import { timeAgo, fmtPrice } from "@/lib/format";
import { Reveal, Stagger, Item } from "@/components/motion/Reveal";
import { Eyebrow, StatusBadge, Direction } from "@/components/shared/Primitives";

export const SignalRow = ({ s, index, compact = false }) => (
  <Link to={`/signals/${s.id}`} data-testid={`signal-row-${s.id}`} className="group row-line row-hover grid grid-cols-12 items-center gap-4 py-6 -mx-4 px-4 rounded-xl">
    <div className="col-span-12 sm:col-span-4 flex items-center gap-4">
      {index !== undefined && <span className="hidden sm:inline font-mono text-xs text-[var(--ink-4)] w-5">0{index + 1}</span>}
      <div>
        <p className="t-h5">{s.instrument}</p>
        <div className="mt-1 flex items-center gap-3"><Direction value={s.direction} /><span className="font-mono text-[11px] text-[var(--ink-4)]">{s.timeframe} · {s.id}</span></div>
      </div>
    </div>
    <div className="col-span-8 sm:col-span-5">
      <p className="text-[15px] text-[var(--ink-2)] leading-[1.55] line-clamp-2">{s.summary}</p>
      {!compact && <p className="mt-2 font-mono text-[11px] text-[var(--ink-3)]">Entry {s.entry} · SL {fmtPrice(s.stop)} · TP {s.targets.map(fmtPrice).join(" / ")} · R:R {s.rr}</p>}
    </div>
    <div className="col-span-4 sm:col-span-3 flex items-center justify-end gap-4">
      <div className="text-right">
        <StatusBadge status={s.status} />
        <p className="mt-1.5 font-mono text-[11px] text-[var(--ink-4)]">{timeAgo(s.publishedAt)}</p>
      </div>
      <ArrowUpRight size={18} className="text-[var(--ink-4)] transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-[var(--cobalt)]" />
    </div>
  </Link>
);

export const LatestSignals = () => (
  <section className="section bg-white" data-testid="latest-signals">
    <div className="container-x">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <Reveal>
          <Eyebrow className="mb-4">Market research</Eyebrow>
          <h2 className="t-h2">Latest trading signals</h2>
        </Reveal>
        <Reveal delay={0.1}><Link to="/signals" className="btn-outline" data-testid="signals-preview-cta">Explore trade ideas <ArrowRight size={16} /></Link></Reveal>
      </div>
      <Stagger className="mt-10 border-t border-[var(--line)]">
        {SIGNALS.slice(0, 3).map((s, i) => <Item key={s.id}><SignalRow s={s} index={i} compact /></Item>)}
      </Stagger>
    </div>
  </section>
);
